import cx from "clsx";
import React from "react";
import useWindowWidth from "../../hooks/useWindowWidth";
import { Button } from "../common";
import { Cross } from "../common/Icons";
import LinkNoStyle from "../common/LinkNoStyle/LinkNoStyle";
import * as styles from "./MyBasketSponsorDogCard.module.scss";

import { useMyAccountUK } from "../../context";
import { isSpecificSite } from "../../utils/isSpecificSite";
import ProcessedImage from "../common/ProcessedImage/ProcessedImage";
export interface MyBasketSponsorDogCardProps {
	basketKey: number;
	sponsorDog: DogsTrust.SADCookie;
	fullWidth?: boolean;
	variant?: "default" | "yellow";
}
const MyBasketSponsorDogCard: React.FC<MyBasketSponsorDogCardProps> = ({
	basketKey,
	sponsorDog,
	fullWidth = false,
	variant = "default",
}) => {
	isSpecificSite("uk", "MyBasketSponsorDogCard");
	const { profile, handleRemoveFromBasket, handleRecipientChange } =
		useMyAccountUK();
	const windowWidth = useWindowWidth();
	const onChangeRecipient = (who: "myself" | "gift") => {
		handleRecipientChange(basketKey, who === "gift");
	};

	return (
		<div
			className={cx(
				fullWidth && windowWidth > 900
					? styles.fullwidthcontainer
					: styles.container,
				styles[variant],
			)}
		>
			<button
				type="button"
				onClick={() => handleRemoveFromBasket(sponsorDog, basketKey)}
				className={styles.removesponsorship}
			>
				<Cross height={"12px"} width={"12px"} />
				<span>Remove sponsorship</span>
			</button>

			<div className={styles.content}>
				<div className={styles.dogdetails}>
					<div className={styles.dogimage}>
						<ProcessedImage
							src={sponsorDog.imagePath}
							alt={sponsorDog.name}
							dimensions="120x90"
							width={120}
							height={90}
							loading={"lazy"}
						/>
					</div>
					<LinkNoStyle
						to={sponsorDog.profileUrl}
						className={styles.dogdetailstext}
					>
						<h2 className={styles.sponsordogname}>{sponsorDog.name}</h2>
						<p>{sponsorDog.breed}</p>
					</LinkNoStyle>
				</div>
				<div className={styles.sponsorcontrols}>
					<div className={styles.sponsorcontrolstitle}>
						<h3 className={styles.whosponsortitle}>
							Who are you sponsoring for
						</h3>
					</div>
					<div className={styles.sponsorcontrolsbuttons}>
						<Button
							className={styles.sponsorcontrolbutton}
							variant={
								profile.basket[basketKey].isGift ? "tertiary" : "primary"
							}
							title={"Myself"}
							onClick={() => onChangeRecipient("myself")}
						>
							Myself
						</Button>
						<Button
							className={styles.sponsorcontrolbutton}
							variant={
								!profile.basket[basketKey].isGift ? "tertiary" : "primary"
							}
							title={"As a gift"}
							onClick={() => onChangeRecipient("gift")}
						>
							As a gift
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MyBasketSponsorDogCard;
